import { render, staticRenderFns } from "./ManageNoticeListPanel.vue?vue&type=template&id=b7f47380&scoped=true&lang=pug&"
import script from "./ManageNoticeListPanel.vue?vue&type=script&lang=ts&"
export * from "./ManageNoticeListPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ManageNoticeListPanel.vue?vue&type=style&index=0&id=b7f47380&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f47380",
  null
  
)

export default component.exports